import React, { useState, useEffect } from 'react';
import { Table, Card, Input, Button, Space, Tag, Modal } from 'antd';
import { SearchOutlined, ReloadOutlined, EyeOutlined } from '@ant-design/icons';
import { getPromises } from '../../api/admin';

const ITEM_NAMES = {
  1: '先执行再优化',
  2: '守时守信守规矩',
  3: '沟通坦诚讲真话',
  4: '主动担当不甩锅',
  5: '以身作则带队伍',
  6: '目标导向重实绩'
};

const PromiseManage = () => {
  const [promises, setPromises] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ page: 1, size: 20, keyword: '' });
  const [viewRecord, setViewRecord] = useState(null);

  const fetchData = async (p = params) => {
    setLoading(true);
    try {
      const res = await getPromises(p);
      if (res.code === 200) {
        setPromises(res.data.promises);
        setTotal(res.data.total);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const handleSearch = () => {
    const newParams = { ...params, page: 1 };
    setParams(newParams);
    fetchData(newParams);
  };

  const handleReset = () => {
    const newParams = { page: 1, size: 20, keyword: '' };
    setParams(newParams);
    fetchData(newParams);
  };

  const columns = [
    {
      title: '序号',
      key: 'index',
      width: 60,
      render: (_, __, idx) => (params.page - 1) * params.size + idx + 1
    },
    {
      title: '工号',
      dataIndex: ['user', 'employee_id'],
      key: 'employee_id',
      width: 100
    },
    {
      title: '姓名',
      dataIndex: ['user', 'name'],
      key: 'name',
      width: 90
    },
    {
      title: '部门',
      dataIndex: ['user', 'department'],
      key: 'department',
      width: 120
    },
    {
      title: '薄弱项',
      dataIndex: 'weak_item',
      key: 'weak_item',
      width: 160,
      render: (v) => v ? <Tag color="orange">准则{v}：{ITEM_NAMES[v]}</Tag> : '-'
    },
    {
      title: '承诺内容',
      dataIndex: 'promise_content',
      key: 'promise_content',
      ellipsis: true,
      render: (text, record) => (
        <Space>
          <span style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }}>
            {text}
          </span>
          <Button
            type="link"
            size="small"
            icon={<EyeOutlined />}
            onClick={() => setViewRecord(record)}
          >
            查看
          </Button>
        </Space>
      )
    },
    {
      title: '字数',
      dataIndex: 'word_count',
      key: 'word_count',
      width: 70
    },
    {
      title: '提交时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 170,
      render: (v) => v ? new Date(v).toLocaleString('zh-CN') : '-'
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Space wrap>
          <Input
            placeholder="搜索工号/姓名"
            prefix={<SearchOutlined />}
            value={params.keyword}
            onChange={e => setParams({ ...params, keyword: e.target.value })}
            onPressEnter={handleSearch}
            style={{ width: 180 }}
          />
          <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
          <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
        </Space>
      </div>

      <Card>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={promises}
          loading={loading}
          pagination={{
            current: params.page,
            pageSize: params.size,
            total,
            showSizeChanger: true,
            showTotal: t => `共 ${t} 条`,
            onChange: (page, size) => {
              const newParams = { ...params, page, size };
              setParams(newParams);
              fetchData(newParams);
            }
          }}
          scroll={{ x: 900 }}
        />
      </Card>

      {/* 查看承诺详情弹窗 */}
      <Modal
        title="承诺内容详情"
        open={!!viewRecord}
        onCancel={() => setViewRecord(null)}
        footer={<Button onClick={() => setViewRecord(null)}>关闭</Button>}
      >
        {viewRecord && (
          <div>
            <p><strong>姓名：</strong>{viewRecord.user?.name}</p>
            <p><strong>工号：</strong>{viewRecord.user?.employee_id}</p>
            <p><strong>部门：</strong>{viewRecord.user?.department}</p>
            <p><strong>薄弱项：</strong>准则{viewRecord.weak_item}——{ITEM_NAMES[viewRecord.weak_item]}</p>
            <p><strong>字数：</strong>{viewRecord.word_count} 字</p>
            <p><strong>提交时间：</strong>{viewRecord.created_at ? new Date(viewRecord.created_at).toLocaleString('zh-CN') : '-'}</p>
            <div style={{ marginTop: 12 }}>
              <strong>承诺内容：</strong>
              <div style={{
                marginTop: 8,
                padding: '12px 16px',
                background: '#f5f5f5',
                borderRadius: 6,
                lineHeight: '1.8',
                whiteSpace: 'pre-wrap'
              }}>
                {viewRecord.promise_content}
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PromiseManage;
